/**
 * @generated SignedSource<<f7ea9a626e8efc5677e4f052af4afa97>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrandMessageTaskId_brandMessageTaskQuery$variables = {
  id: string;
};
export type BrandMessageTaskId_brandMessageTaskQuery$data = {
  readonly brandMessageTask: {
    readonly description: string | null;
    readonly id: string;
    readonly isActive: boolean;
    readonly period: number | null;
    readonly query: string;
    readonly startAt: any;
    readonly template: {
      readonly id: string;
      readonly templateCode: string;
      readonly templateName: string;
      readonly " $fragmentSpreads": FragmentRefs<"BrandMessageTaskCreateDialog_brandMessageTemplate">;
    };
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"BrandMessageTaskDescriptionList_brandMessageTask">;
  };
};
export type BrandMessageTaskId_brandMessageTaskQuery = {
  response: BrandMessageTaskId_brandMessageTaskQuery$data;
  variables: BrandMessageTaskId_brandMessageTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "query",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "period",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateCode",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandMessageTaskId_brandMessageTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandMessageTask",
        "kind": "LinkedField",
        "name": "brandMessageTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandMessageTemplate",
            "kind": "LinkedField",
            "name": "template",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BrandMessageTaskCreateDialog_brandMessageTemplate"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BrandMessageTaskDescriptionList_brandMessageTask"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandMessageTaskId_brandMessageTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandMessageTask",
        "kind": "LinkedField",
        "name": "brandMessageTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandMessageTemplate",
            "kind": "LinkedField",
            "name": "template",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parameterNames",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updateTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandMessageButton",
                "kind": "LinkedField",
                "name": "buttons",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkMobile",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkIos",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "picture",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDeleted",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3ab6fd2997788f550feb6ed0984ed73f",
    "id": null,
    "metadata": {},
    "name": "BrandMessageTaskId_brandMessageTaskQuery",
    "operationKind": "query",
    "text": "query BrandMessageTaskId_brandMessageTaskQuery(\n  $id: ID!\n) {\n  brandMessageTask(id: $id) {\n    id\n    title\n    description\n    query\n    startAt\n    isActive\n    period\n    template {\n      id\n      templateCode\n      templateName\n      ...BrandMessageTaskCreateDialog_brandMessageTemplate\n    }\n    ...BrandMessageTaskDescriptionList_brandMessageTask\n  }\n}\n\nfragment BrandMessageTaskCreateDialog_brandMessageTemplate on BrandMessageTemplate {\n  id\n  content\n  parameterNames\n}\n\nfragment BrandMessageTaskDescriptionList_brandMessageTask on BrandMessageTask {\n  id\n  description\n  period\n  query\n  startAt\n  created\n  createdBy {\n    ...UserAvatarText_user\n    id\n  }\n  isActive\n  template {\n    id\n    templateCode\n    templateName\n    createTime\n    serviceStatus\n    updateTime\n    parameterNames\n    imageLink\n    imageUrl\n    content\n    buttons {\n      name\n      linkMobile\n      linkType\n      linkIos\n    }\n  }\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "252a7308f3bbf24bcee4787ec4bb814c";

export default node;
